module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"general-error":"Encontramos um problema","validation-error":"Há algum problema nas informações fornecidas. Verifique as mensagens de erro em cada campo."}}')
  delete Component.options._Ctor
}
